import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { MenuItem } from '../../context-menus/components/menu-item';
import { useUpdateDispositionModal } from '../../dispositions/hooks/use-update-disposition-modal';

export function EditDispositionMenuItem({
    contextMenuItemView,
    clickParams,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const { openEventPanelAndShowUpdateDispositionModal } = useUpdateDispositionModal({
        eventId: clickParams.eventId,
        isTriggeredFromEventPanel: true,
    });

    const handleSelect = (): void => {
        openEventPanelAndShowUpdateDispositionModal();
    };

    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
